import React from 'react';
import { Link } from 'react-router-dom';

const Maintenance: React.FC = () => {
    return (
        <>
            {/* Page body */}
            <div className="coverimg h-100 w-100 top-0 start-0 position-absolute z-index-0 opacity-50">
                <img src={asset('assets/img/adminuiux/image-3.jpg')} alt="" />
            </div>

            {/* center wrap */}
            <div className="row justify-content-center align-items-center vh-100 position-relative z-index-1">
                <div className="col-12 col-md-9 col-lg-8 col-xl-7 text-center py-3 py-lg-4 maxwidth-dynamic" style={{ '--mw-dynamic': '700px' } as React.CSSProperties}>

                    <img src={asset('assets/img/adminuiux/maintanance.png')} alt="" className="width-300 mb-3 mb-lg-4" />

                    <h1>Maintenance Ongoing</h1>
                    <h4 className="mb-4">This page is under maintenance.</h4>

                    <p className="text-secondary mb-3 mb-lg-4">We are in the process of updating features and provide you a best experience.<br />Kindly wait for <b>21-12-2026, 12:00 pm GMT 30:00</b> till we setup all our new feature. All the other things are working fine and you can continue with your tasks.</p>
                    <Link to="/app/dashboard" className="btn btn-theme z-index-5"><i className="bi bi-arrow-left"></i> Go back to Home </Link>
                    <br />

                    <p className="opacity-50 my-2 my-lg-3">Stay tuned with us</p>
                    <ul className="nav justify-content-center">
                        <li className="nav-item">
                            <a className="nav-link" href="https://www.facebook.com/adminuiux/" target="_blank">
                                <i className="bi bi-facebook h5"></i>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://twitter.com/admiinuiux" target="_blank">
                                <i className="bi bi-twitter h5"></i>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://linkedin.com/company/adminuiux" target="_blank">
                                <i className="bi bi-linkedin h5"></i>
                            </a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link" href="https://www.instagram.com/adminuiux/" target="_blank">
                                <i className="bi bi-instagram h5"></i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
};

export default Maintenance;
